<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual id="ground" title="Solution" src="/images/sub/subvisual-solution.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first">
            <template #titleLine>
                Smart Farm Solution
            </template>
            <tit-wrap-large>
                A system that identifies crops’ necessary elements by acquiring data on the soil environment <br class="d-none d-lg-block" /><b>Outdoor Smart Farm</b>
                <template #text>
                    The system supplies the proper amount of water and nutrients required <br class="d-none d-lg-block" />for crops growing in outdoor soil, which is difficult for artificial environment management. <br class="d-none d-lg-block" />It enables efficient soil cultivation environment management and enhances the efficiency and productivity of crops. <br class="d-none d-lg-block" />
                    It maintains the optimal crop growth environment by continuously monitoring the outdoor cultivation environment <br class="d-none d-lg-block" />and root zones of crops and controlling nutrients and irrigation.
                </template>
            </tit-wrap-large>
        </page-section>

        <v-container>
            <v-divider class="grey lighten-3" />
        </v-container>

        <page-section>
            <page-section class="page-section--sm py-0">
                <template #pageSectionImmersive>
                    <v-row class="mx-n20px my-n10px mx-md-n30px my-md-n20px">
                        <v-col cols="12" md="6" class="px-20px py-10px px-md-30px py-md-20px" data-aos="fade-left" data-aos-delay="200">
                            <v-card outlined rounded="">
                                <v-responsive :aspect-ratio="570 / 456" content-class="d-flex">
                                    <v-img max-width="570" :aspect-ratio="570 / 456" src="/images/sub/solution/smartfarm/ground-img.jpg" class="ma-auto" />
                                </v-responsive>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" class="px-20px py-10px px-md-30px py-md-20px" data-aos="fade-right" data-aos-delay="200">
                            <div>
                                <tit-wrap-sprout>
                                    Outdoor Smart Farm
                                    <template #text>
                                        Crop cultivation soil data collector
                                    </template>
                                </tit-wrap-sprout>

                                <txt-item titleClass="w-md-140px">
                                    <template #title>Measurement items</template>
                                    External temperature, humidity, radiant/soil temperature, EC, and moisture
                                </txt-item>
                                <div class="mt-16px mt-md-24px">
                                    <v-img max-width="496" :aspect-ratio="496 / 272" src="/images/sub/solution/smartfarm/ground-img2-en.png" />
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-card rounded="" color="grey lighten-5" data-aos="fade" data-aos-delay="100">
                        <v-responsive :aspect-ratio="1200 / 770" content-class="d-flex align-center justify-center">
                            <div class="pa-30px pa-md-40px px-lg-80px">
                                <v-img max-width="600" :width="$vuetify.breakpoint.lgAndUp ? '600' : ''" :aspect-ratio="600 / 376" src="/images/sub/solution/smartfarm/ground-img3.png" class="mx-auto" />
                                <div class="pt-30px pt-md-40px pt-lg-60px">
                                    <tit-wrap-small>
                                        Easy and simple real-time monitoring via the Internet and mobile device
                                        <template #text>You can easily monitor data on the crop cultivation soil via the Internet and mobile device.</template>
                                    </tit-wrap-small>
                                </div>
                            </div>
                        </v-responsive>
                    </v-card>
                </template>
            </page-section>
        </page-section>

        <v-container>
            <v-divider class="grey lighten-3" />
        </v-container>

        <page-section id="ground-portfolio" class="page-section--last">
            <template #title>
                Portfolio
            </template>
            <div></div>

            <template #pageSectionImmersive>
                <div style="max-width:1480px" class="mx-auto px-12px">
                    <ground-slide />
                </div>
            </template>
        </page-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import TitWrapSmall from "@/components/dumb/tit-wrap-small.vue";
import TitWrapLarge from "@/components/dumb/tit-wrap-large.vue";
import TitWrapSprout from "@/components/dumb/tit-wrap-sprout.vue";
import TxtItem from "@/components/dumb/txt-item.vue";
import GroundSlide from "@/pages/client/sub/solution/GroundSlide.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        TitWrapSmall,
        TitWrapLarge,
        TitWrapSprout,
        TxtItem,
        GroundSlide,
    },
    props: {},
    data() {
        return {};
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
    },
};
</script>

<style lang="scss" scoped></style>
